// extracted by mini-css-extract-plugin
export default {"transactionsWrap":"styles_transactionsWrap__zCO2i","sectionTitle":"styles_sectionTitle__j7GDs","infoCardWrap":"styles_infoCardWrap__v1d5w"};